import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BreadCrumbsPageComponent } from "@interfaces";
import { TruncatePipe } from "src/app/pipes/truncate.pipe";
import { AbstractComponent } from "../abstract-component";

@Component({
    selector: "app-breadcrumbs",
    standalone: true,
    imports: [CommonModule, RouterModule, TruncatePipe],
    templateUrl: "./breadcrumbs.component.html",
})
export class BreadcrumbsComponent extends AbstractComponent {
    component: BreadCrumbsPageComponent;
    jobsUrl: string;
}
